import { Sidebar } from "./Sidebar";
import React, { useState, useEffect, useContext, useCallback } from "react";
import styled from "styled-components";
import { AuthContext } from "../../context/AuthContext";
import messageService from "../../Services/messageService";
import MensagemSchema from "../Mensagem/MensagemSchema";
import { MessageContainer } from "../Mensagem/MensagemSchemaStyle";
import AiChat from "./AiChat/AiChat"; // Importação do novo Chat de IA

// Quantidade máxima de mensagens exibidas ao mesmo tempo na tela
const MAX_VISIBLE_MESSAGES = 2;

export default function SideBarBox({ children }) {
  const [sideBarState, setSideBarState] = useState(false);
  const {userData} = useContext(AuthContext);

  // --- LÓGICA DE MENSAGENS DO CLIENTE ---
  const { isAuthenticated } = useContext(AuthContext);
  const [messages, setMessages] = useState([]);

  const fetchMessages = useCallback(async () => {
    if (isAuthenticated) {
      try {
        const fetchedMessages = await messageService.getMyMessages();

        // Lê do sessionStorage as mensagens já fechadas pelo usuário nesta sessão
        const closedMessages = JSON.parse(
          sessionStorage.getItem("closedClientMessages") || "[]"
        );

        const newMessages = fetchedMessages.filter(
          (msg) => !closedMessages.includes(msg.id)
        );

        setMessages(newMessages);
      } catch (error) {
        console.error(
          "Não foi possível buscar as mensagens do cliente.",
          error
        );
      }
    } else {
      setMessages([]);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const handleCloseMessage = (messageId) => {
    setMessages((prev) => prev.filter((msg) => msg.id !== messageId));

    const closedMessages = JSON.parse(
      sessionStorage.getItem("closedClientMessages") || "[]"
    );

    if (!closedMessages.includes(messageId)) {
      sessionStorage.setItem(
        "closedClientMessages",
        JSON.stringify([...closedMessages, messageId])
      );
    }
  };
  // --- FIM DA LÓGICA DE MENSAGENS ---

  const handleSidebar = () => {
    setSideBarState(!sideBarState);
  };

  return (
    <>
      {/* Sidebar Lateral Esquerda */}
      <Sidebar isOpen={sideBarState} />

      {/* Botão de Menu (Superior Direito) */}
      <BtnSidebar onClick={handleSidebar}>
        <img src="/logo-golden.png" alt="menu" />
      </BtnSidebar>

      {/* Container de Mensagens do Sistema (Avisos)
          Exibe no máximo 2 por vez; ao fechar uma, a próxima da fila
          entra automaticamente com a animação de slide */}
      <MessageContainer>
        {messages.slice(0, MAX_VISIBLE_MESSAGES).map((msg) => (
          <MensagemSchema
            key={msg.id}
            message={msg}
            onClose={handleCloseMessage}
          />
        ))}
      </MessageContainer>

      {/* Chat de IA (Inferior Direito) 
          Ele só renderiza se o usuário estiver logado 
      */}

      {userData && <AiChat />}
      {/* {isAuthenticated && <AiChat />} */}

      {/* Conteúdo das Páginas */}
      {children}
    </>
  );
}

// Estilização do Botão da Sidebar (Menu Principal)
const BtnSidebar = styled.button`
  position: fixed;
  top: 50px;
  right: 50px;
  z-index: 9999;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    to bottom,
    black,
    rgba(0, 0, 0, 0.8),
    rgba(0, 0, 0, 0.7)
  );
  border: 2px solid black;
  border-radius: 3px;
  cursor: pointer;
  transition: 0.3s;
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 1));

  &:hover {
    transform: scale(1.1);
  }

  img {
    z-index: 9999;
    width: 100%;
    filter: drop-shadow(0 10px 10px rgba(255, 255, 0, 0.2));
    height: 100%;
  }

  @media (max-width: 1000px) {
    top: 20px;
    right: 20px;
  }
`;
